import { useEffect, useRef, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export function useButtonState<T>(compute: () => T): T {
    const [editor] = useLexicalComposerContext();
    const computeRef = useRef(compute);
    computeRef.current = compute;

    const [state, setState] = useState<T>(() =>
        editor.getEditorState().read(computeRef.current),
    );

    useEffect(() => {
        const update = () => {
            const next = editor.getEditorState().read(computeRef.current);
            setState((prev) => (Object.is(prev, next) ? prev : next));
        };
        update();
        return editor.registerUpdateListener(update);
    }, [editor]);

    return state;
}
